// @ts-nocheck
import withGoogleTag from '../../Analytics/GTag/withGoogleTag'
import { Auth } from './Auth'

const AuthWithGoogleTag = withGoogleTag(Auth)

export default AuthWithGoogleTag
